// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"486dea89","239":"8d702e22","453":"34cebc88","732":"77a0354c"}[chunkId] + ".chunk.js";
};